import pages from './metadata.json';

export const SITE_ORIGIN = 'https://cubitplay.com';
export function applyMetadata(path) {
  const page = pages[path] || pages['/404'];
  const url = SITE_ORIGIN + (pages[path] ? path : '/404');
  const isGame = path === '/perfectslice' || path.startsWith('/perfectslice/');
  const iconBase = isGame ? '/perfectslice-icon' : '/favicon';
  const imageUrl = SITE_ORIGIN + (page.image || '/social/cubitplay-og.png');
  const imageAlt = page.imageAlt || page.heading || 'CubitPlay';

  const setLink = (selector, href) => {
    const element = document.head.querySelector(selector);
    if (element) element.setAttribute('href', href);
  };
  setLink('link[rel="icon"][type="image/svg+xml"]', iconBase + '.svg');
  setLink('link[rel="icon"][sizes="32x32"]', iconBase + '.ico');
  setLink('link[rel="apple-touch-icon"]', isGame ? '/perfectslice-apple-touch-icon.png' : '/apple-touch-icon.png');
  setLink('link[rel="manifest"]', isGame ? '/perfectslice.webmanifest' : '/manifest.webmanifest');

  document.title = page.title;

  const setMeta = (attribute, key, content) => {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.appendChild(element); }
    element.setAttribute('content', content);
  };

  setMeta('name', 'description', page.description);
  setMeta('name', 'robots', page.noindex || process.env.NODE_ENV !== 'production' ? 'noindex, follow' : 'index, follow');

  // Open Graph
  [
    ['og:site_name',    'CubitPlay'],
    ['og:type',         'website'],
    ['og:title',        page.title],
    ['og:description',  page.description],
    ['og:url',          url],
    ['og:image',        imageUrl],
    ['og:image:width',  '1200'],
    ['og:image:height', '630'],
    ['og:image:alt',    imageAlt],
  ].forEach(([key, value]) => setMeta('property', key, value));

  // Twitter / X
  [
    ['twitter:card',       'summary_large_image'],
    ['twitter:site',       '@cubitplay'],
    ['twitter:title',      page.title],
    ['twitter:description', page.description],
    ['twitter:image',      imageUrl],
    ['twitter:image:alt',  imageAlt],
  ].forEach(([key, value]) => setMeta('name', key, value));

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = url;
}
